module.exports = __webpack_public_path__ + "img/dialog3-title.a6d8abf2.png";